import { render, staticRenderFns } from "./MainBannersBlockCms.vue?vue&type=template&id=7aea4466&scoped=true&"
import script from "./MainBannersBlockCms.vue?vue&type=script&lang=js&"
export * from "./MainBannersBlockCms.vue?vue&type=script&lang=js&"
import style0 from "./MainBannersBlockCms.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MainBannersBlockCms.vue?vue&type=style&index=1&id=7aea4466&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aea4466",
  null
  
)

export default component.exports